import { ElementType } from 'react';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const StyledTableRegularTypography = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.dataGridRegular })}
`;

export const StyledTableBoldTypography = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.dataGridBold })}
`;

export const StyledAgioH1 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.AgioH1 })};
`;

export const StyledAgioH2 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.AgioH2 })};
`;

export const StyledAgioH3 = styled(Typography)<{ theme?: Theme; component?: ElementType }>`
  ${({ theme }) => ({ ...theme.typography.custom.AgioH3 })};
`;

export const StyledAgioH4 = styled(Typography)<{ theme?: Theme; component?: ElementType }>`
  ${({ theme }) => ({ ...theme.typography.custom.AgioH4 })};
`;

export const StyledAgioH5 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.AgioH5 })};
`;

export const StyledAgioH6 = styled(Typography)<{ theme?: Theme; component?: ElementType }>`
  ${({ theme }) => ({ ...theme.typography.custom.AgioH6 })};
`;

export const StyledNormalText1 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.normalText1 })};
`;

export const StyledNormalText2 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.normalText2 })};
`;

export const StyledNormalText3 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.normalText3 })};
`;

export const StyledNormalText4 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.normalText4 })};
`;

export const StyledNormalText5 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.normalText5 })};
`;

export const StyledNormalText6 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.normalText6 })};
`;

export const StyledNormalText7 = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.normalText7 })};
`;

export const StyledBoxTitle = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.boxTitle })};
`;

export const StyledHighChartCustomText = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.highChartCustom })};
`;

export const StyledHighChartDefaultText = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.custom.highChartDefault })};
`;
